import axios from 'axios'
import {ResponseObjectUpload} from '../../../../../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function uploadTemplateService(test: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/module/bulkLoad`, test)
}
